/**
 * 運搬終了報告 区間による表示項目の切り替え
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest`

export default {
  namespaced: true,
  actions: {
    /**
     * 対象マニフェストの区間に設定された内容を取得する
     * @param commit
     * @param id マニフェストID
     * @param section_no 区間番号
     * @param process_type
     * @return {Promise<unknown>}
     */
    show ({ commit }, { id, section_no, process_type }) {
      const params = { process_type: process_type }
      const api_path = `${API_PATH}/${id}/manifest_details/${section_no}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
}
